'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var legendSetsInit = exports.legendSetsInit = undefined;

exports.legendSetsInit = legendSetsInit = function legendSetsInit(c) {
    var t = this,
        appManager = c.appManager,
        requestManager = c.requestManager,
        apiPath = appManager.getApiPath(),
        displayPropertyUrl = appManager.getDisplayPropertyUrl();

    return {
        baseUrl: apiPath + '/legendSets.json',
        params: ['fields=id,displayName~rename(name),legends[id,displayName~rename(name),startValue,endValue,color]', 'paging=false'],
        success: function success(r) {
            appManager.addLegendSets(r.legendSets);
            requestManager.ok(this);
        }
    };
};
//# sourceMappingURL=legendSetsInit.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/lib/init/legendSetsInit.js
 ** module id = 131
 ** module chunks = 0 1
 **/